import { queryOptions } from "@tanstack/react-query";
import { getMyCrSuggestion } from "./cr-suggestion-detail-api";
import { listCrSuggestionsForCr, listMyCrSuggestions } from "./cr-suggestions-api";

export const crSuggestionsQueries = {
  all: () => ["cr-suggestions"] as const,

  /** CR-183: the caller's own suggestions on a project (contributor view). */
  mine: (projectId: string) =>
    queryOptions({
      queryKey: [...crSuggestionsQueries.all(), "mine", projectId] as const,
      queryFn: () => listMyCrSuggestions(projectId),
    }),

  /** CR-235: one of the caller's suggestions, with its attachments (contributor view). */
  myDetail: (suggestionId: string) =>
    queryOptions({
      queryKey: [...crSuggestionsQueries.all(), "my-detail", suggestionId] as const,
      queryFn: () => getMyCrSuggestion(suggestionId),
    }),

  /** CR-183: the suggestions attached to one CR (member view). */
  byCr: (crId: string) =>
    queryOptions({
      queryKey: [...crSuggestionsQueries.all(), "cr", crId] as const,
      queryFn: () => listCrSuggestionsForCr(crId),
    }),
};
